// import Splide from "@splidejs/splide";
// import "@splidejs/splide/css/core";
import Swiper from "swiper";
import "swiper/css";

export default function modalCarousel() {
	const swiper = new Swiper(this.$refs.carousel, {
		slidesPerView: 1,
		spaceBetween: 36,
		// loop: true,
		// on: {
		// 	slideChange: function () {
		// 		console.log(this.activeIndex);
		// 	},
		// },
	});
	return {
		modalOpen: false,
		toggleModal() {
			this.modalOpen = !this.modalOpen;
			if (this.modalOpen) {
				this.$nextTick(() => {
					this.$focus.last();
				});
			}
		},
		next() {
			// console.log("next");
			if (swiper.isEnd) {
				swiper.slideTo(0, 1000);
				return;
			}
			swiper.slideNext();
		},
		prev() {
			// console.log("prev");
			if (swiper.isBeginning) {
				swiper.slideTo(swiper.slides.length - 1, 1000);
				return;
			}
			swiper.slidePrev();
		},
		goTo(index) {
			// console.log(index);
			const target = index - 1;
			swiper.slideTo(target);
		},
	};
}
